 // eslint-disable
<template>
  <div>
    <common ref="common" />
    <div class="f-c hide-500">
      <v-avatar class="header-avatar-layout" size="12em" tile>
        <!-- <span class="headline">EL</span> -->
        <img src="../../assets/weSupport.png" style="object-fit: contain" />
      </v-avatar>
    </div>
    <p class="text-center font-weight-bold display-2 secondary--text mb-2">
      Welcome
    </p>

    <!-- sign up steper begins -->
    <v-stepper
      alt-labels
      v-model="signUpStep"
      style="box-shadow: none;"
    >
      <v-stepper-header class="hide-step-header">
        <v-stepper-step step="1">Enter your mobile number</v-stepper-step>
        <v-stepper-step step="2">Enter Last 4 Digits Of Aadhaar</v-stepper-step>
        <v-stepper-step step="3">Enter New 4 Digit Pin</v-stepper-step>
        <v-stepper-step step="4">Re Enter New 4 Digit Pin</v-stepper-step>
        <v-stepper-step step="5">Enter Your Pin</v-stepper-step>
      </v-stepper-header>

      <v-stepper-content step="1" class="mt-1 pt-1">
        <ValidationObserver ref="obs" v-slot="{ invalid, validated, passes }">
          <p class="text-center mb-1" style="font-size: 0.9em">
            👋🏻 Please sign-in to your account
          </p>
          <v-col cols="12" class="pb-0 py-2">
            <ValidationProvider
              name="Mobile Number"
              type="number"
              :rules="{
                min: 10,
                max: 10,
                numeric: true,
                regex: /[6789][0-9]{9}/,
              }"
              v-slot="{ errors }"
            >
              <v-text-field
                label="Mobile Number"
                prefix="+91"
                outlined
                type="number"
                :error-messages="errors"
                name="mobile number"
                v-model="MobileNo"
                @keydown.enter="verifyUser()"
              ></v-text-field>
            </ValidationProvider>
          </v-col>
          <p
            class="text-center grey--text darken-4 mb-6"
            style="font-size: 0.8em; font-weight: 500"
          >
            A 4 digit OTP will be sent to this number.
          </p>

          <div class="my-2 f-c">
            <v-btn
              rounded
              color="primary"
              @click="passes(verifyUser)"
              :disabled="invalid || !validated"
              >Sign In</v-btn
            >
          </div>
        </ValidationObserver>
        <div class="pt-5 text-center">
          <label @click="privacyPolicy = true" class="text-center grey--text darken-4 pr-4"
              style="font-size: 0.8em; font-weight: 500"> 
              Privacy Policy
          </label>
          <label @click="aboutUs = true" class="text-center grey--text darken-4  pr-4"
              style="font-size: 0.8em; font-weight: 500"> 
              About Us
          </label>
           <label @click="contactUs = true" class="text-center grey--text darken-4  pr-4"
              style="font-size: 0.8em; font-weight: 500"> 
              Contact Us
          </label>
          <br>
          <label  @click="termsandConditions = true" class="text-center grey--text darken-4 "
              style="font-size: 0.8em; font-weight: 500"> 
              Terms and Conditions
          </label>
        </div>
      </v-stepper-content>

      <v-stepper-content step="2">
        <otpComponent
          @ConfirmOtp="ConfirmOtp"
          :showCancelButton="false"
          @snackbarShow="snackbarShow"
          ref="otpInput"
          :key="otpComponentKey"
        />
      </v-stepper-content>

      <v-stepper-content step="3">
        <otpComponent
          @ConfirmOtp="newPassword"
          :showCancelButton="false"
          title="Enter 4 Digit Pin"
          @snackbarShow="snackbarShow"
          ref="otpInput"
          :key="otpComponentKey"
        />
      </v-stepper-content>

      <v-stepper-content step="4">
        <otpComponent
          @ConfirmOtp="confirmPassword"
          title="Re Enter 4 Digit Pin"
          :showCancelButton="false"
          @snackbarShow="snackbarShow"
          ref="otpInput"
          :key="otpComponentKey"
        />
      </v-stepper-content>

      <v-stepper-content step="5">
        <otpComponent
          @ConfirmOtp="confirmPin"
          title="Enter Your Pin"
          :showCancelButton="false"
          @snackbarShow="snackbarShow"
          ref="otpInput"
          :key="otpComponentKey"
        />
      </v-stepper-content>
    </v-stepper>
    <div
      v-if="signUpStep == 5"
      @click="forgotPinMethod"
      class="text-center ma-4"
      style="font-size: 1.25rem; font-weight: 500"
    >
      <h6>Forgot Pin ?</h6>
    </div>
    <v-dialog
    transition="dialog-transition"
    v-model="termsandConditions"
    @click="termsandConditions = true"
    scrollable
    >
      <termsandConditions @closeDialog="closeDialog"  />
    </v-dialog>
    <v-dialog
    transition="dialog-transition"
    v-model="privacyPolicy"
    @click="privacyPolicy = true"
    scrollable
    :close-on-back="true"
    >
      <privacyPolicy @closeDialog="closeDialog" />
    </v-dialog>
    <v-dialog
    transition="dialog-transition"
    v-model="aboutUs"
    @click="aboutUs = true"
    scrollable
    >
      <aboutUs @closeDialog="closeDialog"  />
    </v-dialog>
    <v-dialog
    transition="dialog-transition"
    v-model="contactUs"
    @click="contactUs = true"
    scrollable
    >
      <contactUs @closeDialog="closeDialog"  />
    </v-dialog>
    <!-- stepper ends -->
  </div>
</template>
<script>
// import createPassword from './CreatePassword'
// import resetPassword from './ResetPassword'
// import { setToken,  } from "@/utils/auth";
import {
  setToken,
  removeToken,
  removetUserType,
  setUserType,
} from "@/utils/auth";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { callApi } from "@/api/others";
import { encryptor, decryptor } from "@/utils/encryptor";
import otpComponent from "@/components/tools/otpComponent";
import common from "@/components/tools/common"; 
export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    otpComponent,
    common,
    termsandConditions:()=>import("@/components/wesupport/terms/termsandConditions.vue"),
    privacyPolicy:()=>import("@/components/wesupport/terms/privacyPolicy.vue"),
    contactUs:()=>import("@/components/wesupport/terms/contactUs.vue"),
    aboutUs:()=>import("@/components/wesupport/terms/aboutUs.vue"),
  },
  data: () => ({
    passwordLogin: true,
    signUpStep: 1,
    MobileNo: "",
    otpEntered: "",
    passWord: "",
    verifyPassword: "",
    otpDigits: [],
    f: "",
    welcomeDialog: false,
    resetpwd: false,
    pwdCreated: false,
    loginPassword: "",
    otpComponentKey: 999,
    forgotPin: false,
    termsandConditions:false,
    privacyPolicy:false,
    aboutUs:false,
    contactUs:false,
  }),
  mounted() {
    var t = localStorage.getItem(btoa("Admin-Token"));
    if (t) {
      this.$router.push("/").catch((err) => {
        console.log(err);
      });
      this.$store.commit("SET_BOTTOMNAVSHOW", true);
      this.$store.commit("SET_TOPBARSHOW", true);
    } else {
      this.$store.commit("SET_BOTTOMNAVSHOW", false);
      this.$store.commit("SET_TOPBARSHOW", false);
      let d = decryptor(btoa(btoa(btoa("isNewCustomer"))), -19);
      if (d != undefined) {
        if (d == false || d == "false") {
          this.newCustomer = false;
        } else if (d == true || d == "true") {
          this.newCustomer = true;
        }
      }
      document.getElementById("app").classList.remove("override-light-theme");
      history.pushState(null, null, location.href);
      window.onpopstate = function () {
        history.go(1);
      };
    }
  },
  methods: {
    closeDialog() {
        this.termsandConditions = false;
        console.log("🚀 ~ file: Login.vue:259 ~ closeDialog ~  this.termsandConditions :",  this.termsandConditions )
        this.privacyPolicy=false;
        this.aboutUs=false;
        this.contactUs=false;
      },
    forgotPinMethod() {
      this.forgotPin = true;
      this.verifyUser();
    },
    handleOtpInput(r) {
      this.otpDigits[r] = document.getElementById("otpi" + r).value[0];
      if (r < 3) {
        let i = "otpi" + (r + 1);
        document.getElementById(i).focus();
      }
      if (r == 3) {
        this.ConfirmOtp();
      }
    },
    verifyUser() {
      // console.log("Verify User Start");
      var common = this.$refs.common;
      if (this.MobileNo.trim().length === 0) {
        common.showSnackBar(" Mobile Number Required !!!", "error");
        return;
      }
      let url = "/api/wesupport/MobileVerification/VerifyUser";
      let dt = { value: this.MobileNo, type: "mobile" };
      this.$emit("loadingChange", true);
      callApi(url, "post", dt)
        .then((res) => {
          // console.log("Verify User Success");
          //this.$refs.common.ManageResponse(res)
          // console.log("Verify User : ", res.data.data);
          if (res.data.data.verified && !this.forgotPin) {
            if (!res.data.data.userExist) this.sendOtp();
            if (res.data.data.userExist) this.signUpStep = 5;
          }
          // console.log("forget pin : ", this.forgotPin);
          if (res.data.data.verified && this.forgotPin) {
            // console.log("User Exist : ", res.data.data.userExist);
            // if (!res.data.data.userExist) {
            this.sendOtp();
            // }
            // if (res.data.data.userExist) {
            //   this.signUpStep = 5;
            // }
          }
          if(!res.data.data.userExist) {
            common.showSnackBar("User does not exist !!", "error");
            return;
          }
        })
        .catch((err) => {
          common.ManageResponse(err.response);
        })
        .finally(() => {
          // console.log("Verify User Final");
          this.$emit("loadingChange", false);
        });
    },
    sendOtp() {
      // console.log("Send OTP");
      // let dom = returnURL()
      var common = this.$refs.common;
      if (this.MobileNo.trim().length === 0) {
        common.showSnackBar(" Mobile Number Required !!!", "error");
        return;
      }
      let url = "/api/wesupport/MobileVerification/GenerateOtp";
      let dt = { value: this.MobileNo, type: "mobile", repeatPunchIn: false };
      this.$emit("loadingChange", true);
      callApi(url, "post", dt)
        .then(() => {
          //this.$refs.common.ManageResponse(res)
          // console.log("Send OTP : ", res);
          this.signUpStep = 2;
        })
        .catch((err) => {
          // console.log("Send OTP Error : ", err);
          this.$refs.common.ManageResponse(err.response);
        })
        .finally(() => {
          this.$emit("loadingChange", false);
        });
      // setTimeout(() => {
      //   document.getElementById("otpi0").focus();
      // }, 1000);
    },
    ConfirmOtp(v) {
      if (v.length == 4) {
        var common = this.$refs.common;
        this.otpEntered = v;
        let url = "/api/wesupport/MobileVerification/VerifyOtp";
        let dt = { value: this.MobileNo, type: "mobile", otp: v };
        this.$emit("loadingChange", true);
        callApi(url, "post", dt)
          .then((res) => {
            // console.log(res);
            // if (res.data.data.includes res.data.data.includes('route')) {
            //   let r = res.data.data.split(',')[1]
            //   this.$store.commit('SET_TOPBARSHOW', true)
            //   this.$store.commit('SET_BOTTOMNAVSHOW', true)
            //   this.$store.commit('SET_LOGGEDOUT', false)
            //   encryptor(this.MobileNo, btoa(btoa(btoa('mobno'))), 19)
            //   encryptor('false', btoa(btoa(btoa('isNewCustomer'))), 19)
            //   document
            //     .getElementById('app')
            //     .classList.add('override-light-theme')
            //   setToken(res.data.refreshToken)
            //   if (res.data.Data) {
            //     this.$router.push(r)
            //   } else {
            //     this.$router.push('/')
            //   }
            // } else {
            //   this.welcomeDialog = true
            //   this.$refs.common.ManageResponse(res)
            // }

            common.showSnackBar(" OTP Verified Successfully !!!", "success");
            this.signUpStep = 3;
            setTimeout(() => {
              this.$store.commit("SET_TOPBARSHOW", true);
              this.$store.commit("SET_BOTTOMNAVSHOW", true);
              this.$store.commit("SET_LOGGEDOUT", false);
              encryptor(this.MobileNo, btoa(btoa(btoa("mobno"))), 19);
              encryptor("false", btoa(btoa(btoa("isNewCustomer"))), 19);
              document
                .getElementById("app")
                .classList.add("override-light-theme");
              setToken(res.data.data.token);
              setUserType(res.data.data.userType);
              console.log("🚀 ~ file: Login.vue:323 ~ setTimeout ~ res.data.data.userType:", res.data.data.userType)
              // this.$router.push("/");
              this.$emit("loadingChange", false);
              this.$emit("userTypeChange", "");
              // location.reload();
            }, 500);
          })
          .catch((err) => {
            if (err.response.data.errors.errors[0] === "Invalid User") {
              this.$refs.otpInput.otpEntered = "";
              this.otpComponentKey++;
              this.signUpStep = 1;
            } else if (
              err.response.data.errors.errors[0] === "OTP invalid !!"
            ) {
              this.$refs.otpInput.otpEntered = "";
              this.otpComponentKey++;
              this.signUpStep = 2;
            }
            this.$refs.common.ManageResponse(err.response);
          })
          .finally(() => {
            this.$emit("loadingChange", false);
          });
      }
    },
    confirmPin(v) {
      if (v.length == 4) {
        var common = this.$refs.common;
        this.otpEntered = v;
        let url = "/api/wesupport/MobileVerification/VerifyPin";
        let dt = { value: this.MobileNo, type: "mobile", pin: v };
        this.$emit("loadingChange", true);
        callApi(url, "post", dt)
          .then((res) => {
            common.showSnackBar(" Login Successfully !!!", "success");
            setTimeout(() => {
              encryptor(this.MobileNo, btoa(btoa(btoa("mobno"))), 19);
              encryptor("false", btoa(btoa(btoa("isNewCustomer"))), 19);
              document
                .getElementById("app")
                .classList.add("override-light-theme");
              setToken(res.data.data.token);
              setUserType(res.data.data.userType);
              this.$store.commit("SET_TOPBARSHOW", true);
              this.$store.commit("SET_BOTTOMNAVSHOW", true);
              this.$store.commit("SET_LOGGEDOUT", false);
              this.$router.push("/");
              // this.$emit("loadingChange", false);
              this.$emit("userTypeChange", "");
              location.reload();
            }, 500);
          })
          .catch((err) => {
            if (err.response.data.errors.errors[0] === "Invalid User") {
              this.$refs.otpInput.otpEntered = "";
              this.otpComponentKey++;
              this.signUpStep = 1;
            } else if (
              err.response.data.errors.errors[0] === "OTP invalid !!"
            ) {
              this.$refs.otpInput.otpEntered = "";
              this.otpComponentKey++;
              this.signUpStep = 2;
            }
            this.$refs.common.ManageResponse(err.response);
          })
          .finally(() => {
            this.$emit("loadingChange", false);
          });
      }
    },
    updatePassword(v) {
      if (v.length == 4) {
        this.otpEntered = v;
        let url = "/api/wesupport/MobileVerification/VerifyOtp";
        let dt = { value: this.MobileNo, type: "mobile", otp: v };
        this.$emit("loadingChange", true);
        callApi(url, "post", dt)
          .then((res) => {
            removeToken("Admin-Token");
            removetUserType();
            location.href = "/#/login";
            location.reload();
            // if (res.data.data.includes res.data.data.includes('route')) {
            //   let r = res.data.data.split(',')[1]
            //   this.$store.commit('SET_TOPBARSHOW', true)
            //   this.$store.commit('SET_BOTTOMNAVSHOW', true)
            //   this.$store.commit('SET_LOGGEDOUT', false)
            //   encryptor(this.MobileNo, btoa(btoa(btoa('mobno'))), 19)
            //   encryptor('false', btoa(btoa(btoa('isNewCustomer'))), 19)
            //   document
            //     .getElementById('app')
            //     .classList.add('override-light-theme')
            //   setToken(res.data.refreshToken)
            //   if (res.data.Data) {
            //     this.$router.push(r)
            //   } else {
            //     this.$router.push('/')
            //   }
            // } else {
            //   this.welcomeDialog = true
            //   this.$refs.common.ManageResponse(res)
            // }
            this.$store.commit("SET_TOPBARSHOW", true);
            this.$store.commit("SET_BOTTOMNAVSHOW", true);
            this.$store.commit("SET_LOGGEDOUT", false);
            encryptor(this.MobileNo, btoa(btoa(btoa("mobno"))), 19);
            encryptor("false", btoa(btoa(btoa("isNewCustomer"))), 19);
            document
              .getElementById("app")
              .classList.add("override-light-theme");
            setToken(res.data.data.token);
            setUserType(res.data.data.userType);
            // this.$router.push("/");
            this.$emit("loadingChange", false);
            this.$emit("userTypeChange", "");
            // location.reload();
            this.signUpStep = 3;
          })
          .catch((err) => {
            if (err.response.data.errors.errors[0] === "Invalid User") {
              this.$refs.otpInput.otpEntered = "";
              this.otpComponentKey++;
              this.signUpStep = 1;
            } else if (
              err.response.data.errors.errors[0] === "OTP invalid !!"
            ) {
              this.$refs.otpInput.otpEntered = "";
              this.otpComponentKey++;
              this.signUpStep = 2;
            }
            this.$refs.common.ManageResponse(err.response);
          })
          .finally(() => {
            this.$emit("loadingChange", false);
          });
      }
    },
    newPassword(v) {
      if (v.length == 4) {
        this.passWord = v;
        this.signUpStep = 4;
      }
    },
    confirmPassword(v) {
      var common = this.$refs.common;
      if (v.length == 4) {
        this.verifyPassword = v;
        if (this.verifyPassword !== this.verifyPassword) {
          common.showSnackBar(" Pin Mismatch !!!", "error");
          return;
        }
        callApi(
          "/api/wesupport/Member/UpdateMemberPassword?newPassword=" +
            this.verifyPassword,
          "post",
          ""
        )
          .then((res) => {
            // console.log("Confirm Pass : ", res);
            // removeToken("Admin-Token");
            // removetUserType();
            // location.href = "/#/login";
            // location.reload();
            if (res) {
              this.$router.push("/");
              location.reload();
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.$emit("loadingChange", false);
          });
      }
    },
    goHome() {
      this.$store.commit("SET_TOPBARSHOW", true);
      this.$store.commit("SET_BOTTOMNAVSHOW", true);
      this.$router.push("/").catch((err) => {
        console.log(err);
      });
    },
    snackbarShow(a, b, c) {
      this.$emit("showSnackBar", a, b, c);
    },
    changePwdCreated(v, p) {
      this.pwdCreated = v;
      let url = "/api/AccountLogin/Register";
      let dt = { MobileNo: this.MobileNo, Password: p, RepeatPassword: p };
      this.$emit("loadingChange", true);
      callApi(url, "post", dt)
        .then((res) => {
          this.$refs.common.ManageResponse(res);
          this.welcomeDialog = false;
          this.$store.commit("SET_TOPBARSHOW", true);
          this.$store.commit("SET_BOTTOMNAVSHOW", true);
          this.$store.commit("SET_LOGGEDOUT", false);
          // encryptor(p, btoa(btoa(btoa("loginpwd"))), 19);
          encryptor(this.MobileNo, btoa(btoa(btoa("mobno"))), 19);
          encryptor("false", btoa(btoa(btoa("isNewCustomer"))), 19);
          setToken("temporary");
          document.getElementById("app").classList.add("override-light-theme");
          this.$router.push("/shareDetails").catch((err) => {
            console.log(err);
          });
          location.reload();
        })
        .catch((err) => {
          this.$refs.common.ManageResponse(err.response);
        })
        .finally(() => {
          this.$emit("loadingChange", false);
        });
    },
  },
};
</script>

<style>
:root {
  --primary-color: linear-gradient(to right, #ff8100, #ff5504);
  --secondary-color: #a4a4a4;
}
.f-c {
  display: flex;
  justify-content: center;
}
.f-s-a {
  display: flex;
  justify-content: space-around;
}
.f-l {
  display: flex;
  justify-content: flex-start;
}
.header-avatar-layout {
  margin-top: 15vh;
  margin: 3em;
}
.outline {
  border: 2px solid var(--primary-color);
}
.hide-step-header {
  display: none !important;
}
.center-input input {
  text-align: center !important;
}
.theme--dark.v-stepper {
  background: #121212;
}
</style>
